import { ApolloClient } from 'apollo-client'

import { createHttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'
import { SubscriptionClient } from 'subscriptions-transport-ws'

import firebase from 'firebase'

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

const scheme = proto => {
  return window.location.protocol === 'https:' ? `${proto}s` : proto
}

const GRAPHQL_ENDPOINT = `${scheme('http')}://${
  process.env.VUE_APP_HASURA_HOST_NAME
}/v1/graphql`
const WEBSOCKET_ENDPOINT = `${scheme('ws')}://${
  process.env.VUE_APP_HASURA_HOST_NAME
}/v1/graphql`

const getAuthHeader = async () => {
  const headers = {}
  if (!firebase) return headers
  const user = firebase.auth().currentUser
  if (user) {
    const token = await user.getIdToken()
    headers.Authorization = `Bearer ${token}`
  }
  return headers
}

const httpLink = createHttpLink({
  uri: GRAPHQL_ENDPOINT
})

const wsClient = new SubscriptionClient(WEBSOCKET_ENDPOINT, {
  reconnect: true,
  reconnectionAttempts: 10,
  timeout: 30000,
  lazy: true,
  // When connectionParams is a function, it gets evaluated before each connection.
  async connectionParams () {
    let authHeader = await getAuthHeader()
    let headers = {
      ...DEFAULT_HEADERS,
      ...authHeader
    }
    return { headers }
  }
})

const wsLink = process.browser ? new WebSocketLink(wsClient) : null

const authLink = setContext(async (_, { headers }) => {
  // return the headers to the context so HTTP link can read them
  let authHeader = await getAuthHeader()
  // console.log('auth header', authHeader.Authorization)
  return {
    headers: {
      ...headers,
      ...DEFAULT_HEADERS,
      ...authHeader
    }
  }
})

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  authLink.concat(wsLink),
  authLink.concat(httpLink)
)

// Create the apollo client
const apolloClient = new ApolloClient({
  link,
  defaultHttpLink: false,
  cache: new InMemoryCache({
    addTypename: true
  }),
  connectToDevTools: process.env.NODE_ENV !== 'production'
})

export default apolloClient
